import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";

export function Testimonials() {
  const { data: items = [] } = useQuery({
    queryKey: ["testimonials"],
    queryFn: async () => (await api.get("/testimonials")).data,
  });

  if (!items.length) return null;

  return (
    <section className="px-4 md:px-8 mt-10" data-testid="testimonials">
      <div className="mb-4">
        <p className="overline text-primary">Loved across the coast</p>
        <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
          Real stories from real celebrations
        </h2>
      </div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-1 px-1">
        {items.map((t, i) => (
          <motion.div
            key={i}
            data-testid={`testimonial-${i}`}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
            className="shrink-0 w-80 bg-card border border-stone-200 rounded-2xl p-5 flex flex-col"
          >
            <Quote className="h-6 w-6 text-primary/30" />
            <p className="text-sm text-stone-700 mt-2 leading-relaxed flex-1">“{t.quote}”</p>
            <div className="flex items-center gap-0.5 mt-4">
              {[1, 2, 3, 4, 5].map((n) => (
                <Star
                  key={n}
                  className={`h-4 w-4 ${n <= t.rating ? "fill-secondary text-secondary" : "text-stone-300"}`}
                />
              ))}
            </div>
            <div className="mt-2">
              <p className="font-semibold text-sm">{t.name}</p>
              <p className="text-xs text-muted-foreground">
                {[t.event, t.location].filter(Boolean).join(" · ")}
                {t.vendor ? ` · ${t.vendor}` : ""}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
